import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'

import {AttentionIconWarning} from '../../../icons'

const Attention = ({children}) => (
  <Box
    bg="mld.warning.100"
    p="md"
    borderRadius="lg"
    display="flex"
    alignItems="flex-start"
  >
    <Box mr="md">
      <AttentionIconWarning width="1.5em" height="1.5em" />
    </Box>
    <Box flex="1">{children}</Box>
  </Box>
)

Attention.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Attention
